var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "instagram-logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.168 0H5.16797C2.69319 0 0.667969 2.02432 0.667969 4.5V13.5C0.667969 15.9748 2.69319 18 5.16797 18H14.168C16.6427 18 18.668 15.9748 18.668 13.5V4.5C18.668 2.02432 16.6427 0 14.168 0ZM9.66797 12.7499C7.59662 12.7499 5.91789 11.0704 5.91789 9C5.91789 6.92865 7.59662 5.24993 9.66797 5.24993C11.7384 5.24993 13.418 6.92865 13.418 9C13.418 11.0704 11.7384 12.7499 9.66797 12.7499ZM13.418 4.12492C13.418 4.74615 13.9211 5.24992 14.543 5.24992C15.1649 5.24992 15.668 4.74615 15.668 4.12492C15.668 3.5037 15.1649 2.99992 14.543 2.99992C13.9211 2.99992 13.418 3.5037 13.418 4.12492Z",
    fill: "#222222"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramLogo);
export default __webpack_public_path__ + "static/media/instagram-logo.9f16d1f8e776e6eee6b988292b9a4b8a.svg";
export { ForwardRef as ReactComponent };